import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
import CardItem from "../components/cardItem"
class AboutUs extends Component {
	state={
		youshi:[
			{
				name:'名校合作 高端品牌',
				content:'杜克大学，约翰霍普金斯大学，康奈尔大学，乔治城大学，罗切斯特大学，乔治华盛顿大学等顶尖名校合作项目，为优秀学生创造高端平台，一流路线。大部分的美丞的客户进入美国前50强名校。',
			},
			{
				name:'项目多样 出国无忧',
				content:'针对不同学生的留学需求，美丞留学将提供全方位、个性化、多层次的留学项目供学生选择。让每一位选择美丞留学的学生都能做到理性留 学，快乐深造。',
			},
			{
				name:'专业规划 全程跟踪',
				content:'兼顾院校品质和学生潜力，为学生量身定制留学方案，提供海外各校合作联盟的丰富资源，与院校面对面的多样机会，让学生近距离了解海外求学信息。长期的从业经验、大量的案例积累和历年参与海外升学委员会招生官的大学申请培训，使得我们能够精准地把握海外院校的申请要求，理性择校，定位专业，提升软实力，更全面地规划留学之路。',
			},
			{
				name:'团队服务 细心专业',
				content:'美丞顾问从前期咨询至后期规划及申请文案均具备海外名校留学经历或在留学咨询行业从业五年以上。每名顾问所带学生数量上限不得超过15人每年，以追求精细化的服务体验。',
			},
			{
				name:'行前培训 完善周到',
				content:'我们专业的顾问都拥有多年在国外留学或工作的经历。我们会以讲座，实例讲解以及经验分享会等形式对即将出国的学生及家长进行行前培训，让他们全方位了解并提早适应陌生的异国学习和生活环境。',
			},
			{
				name:'延续服务 温馨至诚',
				content:'学生成功奔赴海外，并不意味着美丞留学服务的终止，为了帮助学生融入新的环境，除提供当地住宿安排、协助接机、金融服务推荐、建立全球同学会外，我们还定期进行电话回访，配合与学校沟通协调，学生续签指导 等后续服务。',
			},
			{
				name:'海外实习 海归招聘',
				content:'我们将会为通过我们的学生提供海外就业指导和安排。对于刚毕业想回国工作的学子，可以通过我们的芝麻桥平台，线上参与宣讲招聘会，与知名企业高管对话，获得第一手招聘信息。目前我们与多所世界院校，数百家高端企业合作，服务的学生群体数量达到300万。',
			}
		],
	}
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'banimg'} src={require('../../static/images/aboutimg01.png')} alt=""/>
					<div className={'content'}>
						<div className={'title'}>
							<span>美丞留学介绍</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule'}>
							<div className={'text textJust'}>
								上海美丞文化交流有限公司-美丞留学是经国家教育部、公安部和国家工商总局批准成立的，从事留学咨询服务的专业机构。自 2006年成立以来，美丞留学一直秉承着"成君之美·鼎力相丞"的宗旨，已成功帮助数千名学生实现留学之梦，桃李遍布美国、英国、加拿大、欧洲各地。

								<br/><br/>
								美丞留学拥有极其丰富的美国本科项目申请知识和经验，为客户提供专业合理的个性化留学定制方案。美丞留学拥有完整的留学闭环，从语言培训到留学咨询再到海内外就业，每一个环节都有专业尽责的老师与您同行，为您服务。
								<br/><br/>
								在"打造安心服务，开启新生之门"理念的影响下，美丞留学一直以"超越学生期待，成就美好未来"为目标，为广大学生提供最专业、最优质、最贴心的留学服务，以实现美丞留学"助人才成为精英，助精英成为栋梁"的事业目标。
							</div>
							<img className={'img'} src={require('../../static/images/aboutimg02.png')} alt=""/>
						</div>
						<div className={'guonei'}>
							<div className={'guoneiItem'}>
								<div className={'guoneiItemTitle'}>
									<img src={require('../../static/images/aboutimg03.png')} alt=""/>
									<span>国内大牛咨询师</span>
								</div>
								<div className={'guoneiItemText textJust'}>
									每一位国内咨询师在留学行业从业经验均5年以上，成功帮助众多学生拿到哈佛大学、哥伦比亚大学、芝加哥大学、宾夕法尼亚大学、康奈尔大学、加州大学伯克利分校等美国名校录取。老师们善于挖掘学生亮点，从在校成绩、实习、科研等方面全方位提升学生背景，制定个性化的留学规划方案。
								</div>
							</div>
							<div className={'guoneiItem'}>
								<div className={'guoneiItemTitle'}>
									<img src={require('../../static/images/aboutimg03.png')} alt=""/>
									<span>美国名校导师</span>
								</div>
								<div className={'guoneiItemText textJust'}>
									我们的团队拥有美国名校毕业的名校导师。作为百里挑一的精英，名校导师手把手教你提升背景，超越海内外同辈竞争者。在跟导师畅聊美国文化的同时，不仅可以帮助消除英语交流障碍，更可以提前感受北美国家教育模式、文化等方面与国内的共性与差异。顾问团队均驻扎在上海、南京办公室，走向零时差时代！
								</div>
							</div>
						</div>
						<div className={'title'}>
							<span>美丞留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'mingxiao'} style={{marginTop:'40px'}}>
							{
								this.state.youshi.map((item,index)=>{
									return (
										<div className={'mingxiaoItem aboutItem'} key={index}>
											<div className={'mingxiaoItemTitle line_wrap'}>
												<span className={'line_title'}>
													{item.name}
												</span>
											</div>
											<div className={'mingxiaoItemText textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									)
								})
							}
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default AboutUs